module.exports = __webpack_public_path__ + "static/img/13.9d08396.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/3/zh/13.png
// module id = V4nT
// module chunks = 0